import { render } from "./InlineChannel.vue?vue&type=template&id=3dbb9212&ts=true"
import script from "./InlineChannel.vue?vue&type=script&lang=ts"
export * from "./InlineChannel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/InlineChannel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dbb9212"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dbb9212', __exports__)) {
    api.reload('3dbb9212', __exports__)
  }
  
  module.hot.accept("./InlineChannel.vue?vue&type=template&id=3dbb9212&ts=true", () => {
    api.rerender('3dbb9212', render)
  })

}


export default __exports__